import { authorizeInStoriesOnBoardAndGetToken } from "./storiesonboardauthorizer";
import channel from "@/cqs/channel";
import { CheckAccess } from "@/cqs/remotequeries";
import { SetPersonalAccessToken } from "@/cqs/commands";

export var flashError = (t: any, message: string) => {
    t.alert({
        message: message,
        duration: 15,
        display: 'error'});
}

export var authorizeInStoriesOnBoardAndStoreToken = async (t: any, callback: () => void = null) => {
    var token = await authorizeInStoriesOnBoardAndGetToken();
    try {
        await channel(t).executeQuery(new CheckAccess(token));
        await channel(t).sendCommand(new SetPersonalAccessToken(token));
    }
    catch(e) {
        flashError(t, "Authorization failed. Make sure you're logged in with the correct user, have access to the linked story map and the integration is enabled.");
    }
    finally{            
        if(callback != null) {
            callback();
        }
    }
}